import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './components/button/button.component';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { ButtonGroupTabsComponent } from './components/button-group-tabs/button-group-tabs.component';
import { ButtonGroupComponent } from './components/button-group/button-group.component';
import { ButtonCopyToClipboardComponent } from './components/button-copy-to-clipboard/button-copy-to-clipboard.component';
import { IconButtonGroupComponent } from './components/icon-button-group/icon-button-group.component';
import { SharedUiBadgesModule } from '@shared/ui/badges';
import { VideoCardButtonGroupComponent } from './components/video-card-button-group/video-card-button-group.component';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuModule } from 'primeng/menu';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    SharedUiIconsModule,
    NgbDropdownModule,
    RouterModule,
    NgbNavModule, 
    SharedUiBadgesModule,
    ButtonModule,
    SplitButtonModule,
    MenuModule,
    SelectButtonModule, 
    FormsModule
    ],
  declarations: [
    ButtonComponent,
    ButtonGroupComponent, 
    ButtonGroupTabsComponent, 
    ButtonCopyToClipboardComponent, 
    IconButtonGroupComponent, 
    VideoCardButtonGroupComponent
  ],
  exports: [
    ButtonComponent, 
    ButtonGroupComponent, 
    ButtonGroupTabsComponent, 
    ButtonCopyToClipboardComponent, 
    IconButtonGroupComponent, 
    VideoCardButtonGroupComponent
  ],
})
export class SharedUiButtonsModule {}
